import { Route } from "@angular/router";
import { Role } from "@types";
import { AuthGuard } from "./guards/auth.guard";
import { ForceCreatePasswordGuard } from "./guards/force-create-password.guard";
import { NotForceCreatePasswordGuard } from "./guards/not-force-create-password.guard";
import { PinGuard } from "./guards/pin.guard";
import { RolesGuard } from "./guards/roles.guard";

type RouteAccessPolicy = Pick<Route, "path" | "canActivate"> &
  Partial<Pick<Route, "data">>;

export const callRoutePath = "call";

export const protectedRoutePolicy = (path: string): RouteAccessPolicy => ({
  path,
  canActivate: [AuthGuard, PinGuard, ForceCreatePasswordGuard],
});

const roleProtectedRoutePolicy = (
  path: string,
  role: Role
): RouteAccessPolicy => ({
  path,
  canActivate: [AuthGuard, PinGuard, RolesGuard, ForceCreatePasswordGuard],
  data: { roles: [role] },
});

export const appRouteAccessPolicy: Record<string, RouteAccessPolicy> = {
  admin: roleProtectedRoutePolicy("admin", Role.DepartmentAdmin),
  broadcast: roleProtectedRoutePolicy("broadcast", Role.Broadcaster),
  network: protectedRoutePolicy("network"),
  settings: protectedRoutePolicy("settings"),
  edit: protectedRoutePolicy("edit/:page"),
  profile: protectedRoutePolicy("profile"),
  notifications: protectedRoutePolicy("notifications"),
  processing: protectedRoutePolicy("processing"),
  workspaceAdd: protectedRoutePolicy("onboard/workspace-add"),
  call: protectedRoutePolicy(callRoutePath),
  pin: {
    path: "pin",
    canActivate: [AuthGuard, ForceCreatePasswordGuard],
  },
  setPassword: {
    path: "set-password",
    canActivate: [AuthGuard, NotForceCreatePasswordGuard],
  },
};
